import React from 'react';
import {change as changeFieldValue, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import $ from 'jquery';

import {pagarFormaPagamentoPedido} from '../../actions/reserva/actionsReserva'
import {verificarPagamento} from '../../actions/reserva/actionsReserva';
import {showInfoMsg} from '../../util/messagesUtil';


export class ModalRealizarPagamentoPendente extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            idPedido: '',
            formasPagamentoDto: [],
            botoesDasabilitados: false
        };
    }

    componentDidUpdate(prevProps) {
        const {pedido} = this.props
        if (pedido !== prevProps.pedido) {
            this.setState({
                idPedido: pedido ? pedido.id : null,
                formasPagamentoDto: pedido ? pedido.formasPagamentoDto : null,
            });
        }
    }


    fecharModal() {
        $('#modalRealizarPagamentoPendente')
            .modal('hide');
        $('#modalRealizarPagamentoPendente')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.props.reset('formRealizarPagamentoPendente')
        clearInterval(this.pollingInterval);
    }

    atualizarFormaPagamento(idFormaPagamento, status) {
        this.setState(prevState => {
            const formasPagamentoAtualizadas = prevState.formasPagamentoDto.map(formaPagamento => {
                if (formaPagamento.idFormaPagamento === idFormaPagamento) {
                    return {...formaPagamento, situacao: status};
                } else {
                    return formaPagamento;
                }
            });

            return {formasPagamentoDto: formasPagamentoAtualizadas};
        });
    }

    deParaTipoPagamento(descricao) {
        if (descricao === 'Cartão de débito')
            return 'CARTAO_DEBITO';
        if (descricao === 'Cartão de crédito')
            return 'CARTAO_CREDITO'
    }

    alterarVisibilidadeBotoes(enabled){
        this.setState({botoesDasabilitados: enabled})
    }

    verificarPagamento(formaPagamento) {
        const tipoPagamento = this.deParaTipoPagamento(formaPagamento.tipo)
        this.props.verificarPagamento(this.props.pedido.id, tipoPagamento).then((resp) => {
            if (resp.payload.data === 'APROVADO') {
                clearInterval(this.pollingInterval);
                this.atualizarFormaPagamento(formaPagamento.idFormaPagamento, 'APROVADO');
                this.alterarVisibilidadeBotoes(false)
            }
            if (resp.payload.data === 'CANCELADO') {
                clearInterval(this.pollingInterval);
                this.atualizarFormaPagamento(formaPagamento.idFormaPagamento, 'CANCELADO');
                this.alterarVisibilidadeBotoes(false)
            }
            if (resp.payload.data === 'PENDENTE') {
                clearInterval(this.pollingInterval);
                this.atualizarFormaPagamento(formaPagamento.idFormaPagamento, 'PENDENTE');
            }
            if (resp.payload.data === 'AGUARDANDO_CONFIRMACAO') {
                showInfoMsg('Aguardando confirmação de pagamento')
            }
        })
    }

    realizarPagamento(formaPagamento) {
        this.props.pagarFormaPagamentoPedido(formaPagamento.idFormaPagamento, this.props.empresaSelecionada.id).then((resp) => {
            this.alterarVisibilidadeBotoes(true);
            if (resp) {
                this.pollingInterval = setInterval(() =>
                    this.verificarPagamento(formaPagamento), 15000)
            }
        })

    }

    render() {
        const pedido = this.props.pedido;
        if (!pedido) {
            return null;
        }

        let valorTotalPendente = 0;
        const {formasPagamentoDto} = this.state;

        if (!formasPagamentoDto) {
            return null;
        }

        const valorPendente = formasPagamentoDto.reduce((total, formaPagamento) => {
            if (formaPagamento.situacao !== 'APROVADO') {
                return total + formaPagamento.valor;
            }
            return total;
        }, 0);
        valorTotalPendente += valorPendente;

        return (
            <div className="modal fade show" role="dialog"
                 id="modalRealizarPagamentoPendente" aria-labelledby="modalRealizarPagamentoPendente" aria-hidden="true"
                 data-backdrop="static">
                <div className="modal-dialog modal-info modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title">Pedido {this.props.pedido ? this.props.pedido.id : ''}</h3>
                            <button type="button" className="close" data-dismiss="modal"
                                    onClick={() => this.fecharModal()}
                                    id="btnFecharModalRealizarPagamentoPendente"
                                    aria-label="Close">
                                <i className="material-icons">
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>

                        <div className="modal-body corpo-modal">
                            <h2>Lista de formas de pagamento</h2>
                            <div className="container mt-5">
                                <ul className="list-group">
                                    {formasPagamentoDto.map((formaPagamento) => (
                                        <li key={formaPagamento.idFormaPagamento}
                                            className="list-group-item d-flex justify-content-between align-items-center">
                                    <span style={{fontSize: '1.2em', fontWeight: 'bold', color: '#000'}}>
                                      {formaPagamento.tipo}: {Number(formaPagamento.valor).toLocaleString('pt-br', {
                                        style: 'currency',
                                        currency: 'BRL',
                                    })}
                                    </span>
                                            {formaPagamento.situacao !== 'APROVADO' ? (
                                                <button className="btn btn-laranja btn-sm"
                                                        disabled={this.state.botoesDasabilitados}
                                                        onClick={() => this.realizarPagamento(formaPagamento)}>Pagar</button>
                                            ) : (
                                                <i className="fas fa-check text-success fa-2x"></i>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <p className="mt-3" style={{fontSize: '1.2em', fontWeight: 'bold', color: '#000'}}>
                                Valor total pendente: {Number(valorTotalPendente).toLocaleString('pt-br', {
                                style: 'currency',
                                currency: 'BRL',
                            })}
                            </p>
                        </div>
                        <div className="modal-footer">
              <span style={{fontSize: '1.3em', fontWeight: 'bold', color: '#000'}}
                    className="titulo-mobile float-left">Valor total pedido:&nbsp;{Number(pedido.valorTotalReservas).toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
              })}
              </span>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
        pedido: state.pedido,
    }
}

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        pagarFormaPagamentoPedido,
        verificarPagamento,
        changeFieldValue,
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formRealizarPagamentoPendente',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ModalRealizarPagamentoPendente));
